<template>
  <div class="vue-login-wrap">
    <div>
      <b-modal
      hide-footer
      id="login-modal"
      @hide="cancel"
      :modal-class="myclass">
        <template v-slot:modal-header>
          <span class="close-x" v-on:click="cancel()">×</span>
          <h3>VT Outages Login</h3>
          <!-- <div class="status-messages login">
            <span
            v-if="loginError"
            class="status-message error">{{loginError}}</span>
          </div> -->
        </template>
        <div class="form-container">
            <form>
              <h2
              v-if="forgotPasswordSuccess"
              class="forgot-password-success">Your password has been changed. Please log in below.</h2>
              <div class="form-control-container">
                <label>Username:</label>
                <input
                type="text"
                @keyup.enter="logIn"
                autocorrect="off"
                autocapitalize="none"
                v-model="credentials.username">
              </div>
              <div class="form-control-container">
                <label>Password:</label>
                <input v-model="credentials.password" type="password" @keyup.enter="logIn">
              </div>
              <div class="buttons-container mobile-buttons-container">
                <b-spinner v-if="signingIn" class="spinner"></b-spinner>
                <span
                class="forgot-password-link"
                v-on:click="showForgotPasswordModalClickHander()">Forgot password</span>
                <div v-if="!signingIn">
                  <b-button
                  v-on:click="logIn()"
                  class="btn submit"
                  v-bind:disabled="!credentials.username || !credentials.password">Login</b-button>
                  <span v-if="loginError" class="status-message error">{{loginError}}</span>
                </div>
              </div>
              <div class="buttons-container desktop-buttons-container">
                <b-spinner v-if="signingIn" class="spinner"></b-spinner>
                <span
                class="forgot-password-link"
                v-on:click="showForgotPasswordModalClickHander()">Forgot password</span>
                <div v-if="!signingIn">
                  <b-button
                  v-on:click="logIn()"
                  class="btn submit"
                  v-bind:disabled="!credentials.username || !credentials.password">Login</b-button>
                  <span v-if="loginError" class="status-message error">{{loginError}}</span>
                </div>
              </div>
            </form>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Authentication from "@/services/authentication";
import vueMqMixin from "../mixins/VueMqMixin";

export default {
  name: 'LoginModal',
  mixins: [vueMqMixin],
  props: {
    forgotPasswordSuccess: Boolean,
    hideModal: Function,
    loginSuccess: Function,
    newPasswordRequired: Function,
    showForgotPasswordModal: Function,
  },
  data() {
    return {
      signingIn: undefined,
      credentials: {},
      myclass: [],
      loginError: false
    }
  },
  async created() {
    Vue.nextTick(() => this.$bvModal.show('login-modal'));
    this.myclass = this.isMobile() || this.isTablet() ? ['vt-outages-modal login isMobileOrTablet'] : ['vt-outages-modal login'];
  },
  methods: {
      cancel() {
        this.hideModal();
      },
      showForgotPasswordModalClickHander() {
        this.hideModal();
        this.showForgotPasswordModal();
      },
      async logIn() {
        if (!this.credentials.username) {
          this.loginError = 'Please enter your username';
          return;
        }

        if (!this.credentials.password) {
          this.loginError = 'Please enter your password';
          return;
        }

        this.loginError = false;
        this.signingIn = true;

        try {
          const user = await Authentication.signIn(this.credentials.username, this.credentials.password);
          this.signingIn = undefined;

          if (user.challengeName && user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.newPasswordRequired(user);
          } else {
            this.loginSuccess(user);
          }
        } catch (error) {
            this.loginError = error && error.message ? error.message : 'There was an error signing in';
            this.signingIn = undefined;
            console.log('error signing in', error);
        }
      }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

.spinner{
  height: 40px;
  width: 40px;
  font-size: 22px;
  color: #fbd850;
}

.reset{
  margin-top: 20px;
  text-align: right;

  &:hover{
    cursor: pointer;
  }
}

::v-deep #login-modal{
  .form-container{

    h2{
      &.forgot-password-success{
        margin-bottom: 20px;
        font-weight: $bold;
        font-size: 18px;
        color: $teal;
      }
    }

    .buttons-container{
      position: relative;

      .status-message{
        &.error{
          display: block;
          margin: 10px 0 0 0;
        }
      }

      .forgot-password-link{
        position: absolute;
        top: 5px;
        right: 0;

        &:hover{
          cursor: pointer;
        }
      }

      &.mobile-buttons-container{
        display: none;
        margin-top: 20px;
      }

      &.desktop-buttons-container{
        margin-top: 20px;
      }
    }
  }

  &.isMobileOrTablet{
    .form-container{
      .mobile-buttons-container{
        display: block;
      }
      .desktop-buttons-container{
        display: none;
      }
    }
  }
}
</style>
